import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import { isWeixin } from "@utils";
import { oAuth } from "@libs/wechat";

export default function toLogin(push, backUrl) {
  store.commit("LOGOUT");
  const { fullPath, name } = router.currentRoute;
  cookie.set("login_back_url", backUrl || fullPath);
  if (isWeixin()) {
    oAuth();
  } else {
    if (name !== "Login") {
      push
        ? router.push({ path: "/login" })
        : router.replace({ path: "/login" });
    }
  }
}

export function toBindCoupon() {
    const { fullPath, name } = router.currentRoute;
    if (name !== "BindCoupon") {
      router.replace({path: "/user/bindcoupon", query:{id: "1"}})
    }
}

export function toLoginPhone(backUrl) {
  const { fullPath, name } = router.currentRoute;
  // console.log(fullPath, backUrl,"地址去登录---1");
  // if ((cookie.get("login_back_url") && cookie.get("login_back_url").indexOf("festivalName") !== -1) || (cookie.get("login_back_url") && cookie.get("login_back_url").indexOf("/festival") !== -1)) {
    cookie.set("login_back_url", backUrl || fullPath);
  // }
  if (name !== "Login") {
    router.push({ path: "/login" });
  }


}

